import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const UnsubscribePage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const handleUnsubscribe = async () => {
            const email = searchParams.get('email');
            const type = searchParams.get('type');

            if (!email || !type) {
                setStatus('error');
                setMessage('Invalid unsubscribe link. Missing email or content type.');
                return;
            }

            try {
                const response = await axios.get('/api/notifications/unsubscribe', {
                    params: { email, type }
                });

                setStatus('success');
                setMessage(response.data.message);
            } catch (error) {
                setStatus('error');
                if (error.response?.data?.error) {
                    setMessage(error.response.data.error);
                } else {
                    setMessage('Failed to unsubscribe. Please try again later.');
                }
            }
        };

        handleUnsubscribe();
    }, [searchParams]);

    const handleResubscribe = () => {
        navigate('/settings');
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="unsubscribe-page">
            <div className="unsubscribe-container">
                <div className="unsubscribe-card">
                    <div className="unsubscribe-icon">
                        {status === 'loading' && <span className="material-icons">hourglass_empty</span>}
                        {status === 'success' && <span className="material-icons">check_circle</span>}
                        {status === 'error' && <span className="material-icons">error</span>}
                    </div>
                    
                    <h1 className="unsubscribe-title">
                        {status === 'loading' && 'Processing...'}
                        {status === 'success' && 'Successfully Unsubscribed'}
                        {status === 'error' && 'Error'}
                    </h1>
                    
                    <p className="unsubscribe-message">{message}</p>
                    
                    {status === 'success' && (
                        <div className="unsubscribe-actions">
                            <button onClick={handleResubscribe} className="button-primary">
                                Manage Notification Preferences
                            </button>
                            <button onClick={handleGoHome} className="button-secondary">
                                Go to Homepage
                            </button>
                        </div>
                    )}
                    
                    {status === 'error' && (
                        <div className="unsubscribe-actions">
                            <button onClick={handleGoHome} className="button-primary">
                                Go to Homepage
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UnsubscribePage; 